/* eslint-disable */
import React, { useState, useEffect, useContext } from "react";
import DataTableFilter from "../../Common/DataTableFilter";
import { WebSocketContext } from "../../../App";
import { ClearFormSetFutios } from "../../../redux/actions/adminActions";
import wsSend_request from "../../../Api/ws/ws_request";
import { useSelector, useDispatch } from "react-redux";
import CommonTable from "../../Common/CommonTable";
import { EDIT_NOTIFICATION_AND_CMS_URL } from "../../Shared/constant";

const NetPromoterScore = (props) => {
    const { tab_url, main_url } = props;
    const Dispatch = useDispatch();
    const { NetPromoterScoreNotificationsListing, device_id, selfInfo } = useSelector((state) => state.adminReducers);
    const [ userType, setUserType ] = useState("all");
    const [ userLimit, setUserLimit ] = useState(10);
    const [ currentPage, setCurrentPage ] = useState(1);
    const [ Frequency, setFrequency ] = useState("");
    const { websocket } = useContext(WebSocketContext);
    const PermissionsAccess = selfInfo?.user?.permissions_access;
    
    // page change
    const currentFunction = (page) => {
        setCurrentPage(page);
    };
    
    // select user type
    const SelectUserTypeFnct = (e) => {
        setUserType(e.target.value);
        setCurrentPage(1);
    };

    // api calling
    const APICall = () => {
        if(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.DealerApp[6]?.Edit || PermissionsAccess?.DealerApp[6]?.View)) {
            let param = { 
                "transmit": "broadcast", 
                "url": "list_cms_notifications",
                "request" : { 
                    "status" : userType === "active" ? true : userType === "inactive" ? false : "", 
                    "limit" : userLimit,
                    "page_no" : currentPage, 
                    "type": tab_url,
                    "frequency": Frequency,
                    "order_by": "-updated_at",
                },
                "DeviceId" : device_id
            };
            wsSend_request(websocket, param);
        };
    };

    // when page load api calling
    useEffect(() => {
        APICall();
    }, [ websocket, userType, currentPage, userLimit, Frequency ]);

    useEffect(() => {
        Dispatch(ClearFormSetFutios({
            url:"",
            action:false
        }));
    }, []);

    // TABLE COLUMNS ARRAY
    const TableColumns = [
        { key: 'cms_title', label: 'Title', type: "label", sort: "", isCollapsable: false },
        { key: 'cms_description', label: 'Description', type: "label", sort: "", isCollapsable: false },
        { key: 'created_at', label: 'Added on', type: "date", sort: "", isCollapsable: false },
        { key: 'cms_status', label: 'Status', type: "status_active", sort: "", isCollapsable: false },
    ];

    return(<section className="Main_section">
        <DataTableFilter 
            filterType={"Notifications"}
            searchType={""}
            userType={userType} 
            setUserType={setUserType}
            Frequency={Frequency} 
            setFrequency={setFrequency}
            userLimit={userLimit} 
            setUserLimit={setUserLimit}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            SelectUserTypeFnct={SelectUserTypeFnct}
            buttonvisible={false}
            ButtonSet={{
                buttontitle: "",
                function: ""
            }}
            searchdisable={false}
            ActiveInactiveFilter={true}
        />
        {/* COMMON TABLE */}
        <CommonTable 
            isTableAllow={true}
            style={{
                height: parseInt(NetPromoterScoreNotificationsListing?.pagination?.total_records) === NetPromoterScoreNotificationsListing?.list?.length ? "calc(100vh - 185px)" : parseInt(NetPromoterScoreNotificationsListing?.pagination?.total_records) > 10 ? "calc(100vh - 221px)" : "calc(100vh - 185px)"
            }}
            srNumber={{
                clickable: false,
                events: ""
            }}
            isCollapsable={false}
            tabName={""} // TAB URL
            PaginationCurrentPage={currentPage} // TAB CURRENT PAGE
            PaginationFunction={currentFunction} // PAGINATION CHNAGE FUNCTION
            TableColumns={TableColumns} // TABLE COLLUMNS & ROWS
            OrderList={NetPromoterScoreNotificationsListing} // CATEGORY LIST
            Pagination={NetPromoterScoreNotificationsListing?.pagination} // CURRENT TAB PAGINATION
            EditAccess={(selfInfo?.user?.user_type === 'super_admin' || PermissionsAccess?.DealerApp[6]?.Edit)} // EDITABLE ACCESS STATE
            isActionColumnAvailable={{
                isShow: selfInfo?.user?.user_type === 'super_admin' || PermissionsAccess?.DealerApp[6]?.Edit,
                label: "edit_notification",
                naviagte: `${EDIT_NOTIFICATION_AND_CMS_URL}/${main_url}`,
            }}
            isActionTwoColumnAvailable={{
                isShow: false,
                url: "",
            }}
            isOdiFilterRowColorsAllow={false}
        />
    </section>)
}

export default NetPromoterScore;